import handleAmount from './handle-amount';
import handleItems from './handle-items';

/* eslint-disable */
const isInvalid = val => !!((val === '' || val === null || val && val.length < 1));
/* eslint-disable */

const validate = /* istanbul ignore next */(params, items) => {
  let isValid = true;

   items.forEach((fieldName) => {
     if (isInvalid(params[fieldName])) {
       isValid = false;

      if (fieldName !== 'amount') {
       /* eslint-disable */
        console.warn(`Insira um valor válido para ${fieldName}`);
         /* eslint-disable */
       }
    }
   });

  return isValid;
};

const validateRecurrency = (params) => {
  const requiredItems = [
    'sellerId',
    'token',
  ];

  const requiredItemsUpdateCard = [
    'subscriptionId',
  ];

  const requiredItemsSubscription = [
    'planId',
    'orderId',
  ];

  const requiredItemsCustomer = [
    'customerFirstName',
    'customerLastName',
    'customerDocumentType',
    'customerDocumentNumber',
    'customerAddressStreet',
    'customerAddressNeighborhood',
    'customerAddressCity',
    'customerAddressState',
    'customerAddressZipcode',
    'customerCountry',
  ];

  let items = requiredItems;

  if (JSON.parse(params.updateCard)) {
    items = items.concat(requiredItemsUpdateCard);
  } else if (params.customerId) {
    items = items.concat(requiredItemsSubscription);
  } else {
    items = items.concat(requiredItemsSubscription).concat(requiredItemsCustomer);
  }

  return items;
};

const validateItems = (params) => {
  const requiredItems = [
    'sellerId',
    'token',
    'amount',
  ];

  const requiredItemsNotEncrypted = [
    'orderId',
    'customerId',
    'customerFirstName',
    'customerLastName',
    'customerDocumentType',
    'customerDocumentNumber',
    'customerAddressStreet',
    'customerAddressNeighborhood',
    'customerAddressCity',
    'customerAddressState',
    'customerAddressZipcode',
    'customerCountry',
  ];

  let items = requiredItems;

  if (!params.encrypt) {
    items = items.concat(requiredItemsNotEncrypted);
  }

  return items;
};

export const authenticationItems = (params) => {
  let items = [];

  if (JSON.parse(params.recurrency)) {
    items = items.concat(validateRecurrency(params));
  } else {
    items = items.concat(validateItems(params));
  }

  return true;
};

export const receiveAmount = (recurrency, amount) => {
  if (!JSON.parse(recurrency)) {
    return handleAmount(amount) || '';
  }

  return '0.00';
};

export const receiveItems = (items) => {
  return handleItems(items);
};

export const checkPaymentMethodsDisabled = (el) => {
  if (el && el.indexOf('["') > -1) {
    return JSON.parse(el);
  }

  return null;
};

export const isFormatDate = (currDate) => {
  let regex = /^[0-9][0-9]\/[0-9][0-9]\/[0-9][0-9][0-9][0-9]/;

  return regex.test(currDate);
};

export const validateDate = (currDate) => {
  if (currDate && !isFormatDate(currDate)) {
    console.warn('Data de vencimento precisa estar em um formato válido: DD/MM/AAAA');
    return;
  }

  return currDate;
};

export const receiveDynamicMCC = (dynamicMCC) => {

  let mcc = dynamicMCC;

  if(mcc && mcc !== '' && (mcc.length < 4 || Number.isNaN(Number(mcc)))) {
    mcc = '';
    console.warn("Formato inválido para o MCC dinâmico. O valor deve ser de quatro dígitos numéricos.");
  }

  return mcc;
}



// WEBPACK FOOTER //
// ./src/authentication.js